const sharedComponentsUrl =
  'https://shared-web-components-54e12d.gitlab.io/uglib-shared-web-components.js'

export const onInitialClientRender = () => {
  const alreadyLoaded = Array.from(document.scripts).some(
    script => script.src === sharedComponentsUrl
  )

  if (alreadyLoaded) return

  const script = document.createElement('script')
  script.type = 'module'
  script.src = sharedComponentsUrl
  document.head.appendChild(script)
}